import { createSlice } from "@reduxjs/toolkit";

export const LangConfig = {
  EN: {
    name: "English",
    code: "EN",
    lang: "en",
    icon: "🇺🇸",
    direction: "ltr",
  },
  AR: {
    name: "Arabic",
    code: "AR",
    lang: "ar",
    icon: "🇸🇦",
    direction: "rtl",
  },
};

const initialState = {
  langConfig: LangConfig.EN,
};

const LanguageSlice = createSlice({
  name: "LanguageSlice",
  initialState,
  reducers: {
    updateLangConfig: (state, action) => {
      state.langConfig = action.payload;
    },
  },
});

export const { updateLangConfig } = LanguageSlice.actions;
export default LanguageSlice.reducer;
